import { selectorFamily } from 'recoil';
import Constant from '@/common/constant/Constant';
import TranslationConstant from '@/common/constant/TranslationConstant';
import { contentDetailOnDemandAtom, getListOnDemandAtomByPanelType } from '@/state/atom/translationAtom';

const { ON_DEMAND_TRANSLATION_VIEW } = TranslationConstant;

/**
 * Whether the「翻訳版」toggle of one list view is ON. A boolean, so a list row re-renders only when
 * that toggle flips - not on every translation update of every ticket / view (CR-303134).
 *
 * @param {{ panelType: string, viewKey: string }} params
 */
export const listOnDemandToggleOnSelector = selectorFamily({
    key: 'listOnDemandToggleOnSelector',
    get:
        ({ panelType, viewKey }) =>
        ({ get }) => {
            if (!panelType || !viewKey) return false;
            const listOnDemand = get(getListOnDemandAtomByPanelType(panelType));
            return listOnDemand?.[viewKey]?.activeView === ON_DEMAND_TRANSLATION_VIEW.TRANSLATION;
        }
});

/**
 * Whether the「翻訳版」toggle of one content (detail screen) is ON and the content is not being
 * edited - edit mode always shows the original.
 *
 * @param {string} contentId ticket id (child email id for an email)
 */
export const contentDetailOnDemandToggleOnSelector = selectorFamily({
    key: 'contentDetailOnDemandToggleOnSelector',
    get:
        contentId =>
        ({ get }) => {
            if (!contentId) return false;
            const record = get(contentDetailOnDemandAtom)?.[contentId];
            return (
                record?.activeView === ON_DEMAND_TRANSLATION_VIEW.TRANSLATION &&
                record?.ticketMode !== Constant.DISPLAY_MODE.EDIT
            );
        }
});
